/*
 * Islamboekhandel – link bij kopiëren van productomschrijvingen.
 * Wie een stuk (>= MIN_CHARS tekens) uit de productomschrijving kopieert, krijgt in de
 * HTML-versie op het klembord het eerste woord van meer dan 5 letters als link naar de
 * productpagina (zelfde tekst, geen extra regel). De platte-tekstversie blijft ongewijzigd.
 * Korte kopieeracties (titel, ISBN, een losse zin) blijven ongemoeid.
 * De URL komt van het element .ib-product-description (data-ib-copy-url).
 */
(function () {
  if (window.__ibCopyAttribution) return;
  window.__ibCopyAttribution = true;

  var MIN_CHARS = 120;
  var WORD_RE;
  try { WORD_RE = new RegExp('[\\p{L}\\p{M}]{6,}', 'u'); } catch (e) { WORD_RE = /[A-Za-zÀ-ÖØ-öø-ÿ]{6,}/; }

  function linkFirstLongWord(root, url) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentNode;
      if (parent && parent.closest && parent.closest('a, script, style')) continue;
      var m = WORD_RE.exec(node.nodeValue);
      if (!m) continue;
      var wordNode = node.splitText(m.index);
      wordNode.splitText(m[0].length);
      var a = document.createElement('a');
      a.setAttribute('href', url);
      wordNode.parentNode.insertBefore(a, wordNode);
      a.appendChild(wordNode);
      return true;
    }
    return false;
  }

  document.addEventListener('copy', function (e) {
    try {
      var sel = window.getSelection && window.getSelection();
      if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return;

      var range = sel.getRangeAt(0);
      var node = range.commonAncestorContainer;
      if (node.nodeType !== 1) node = node.parentNode;
      var content = node && node.closest ? node.closest('.ib-product-description__content') : null;
      if (!content) return;

      var text = sel.toString();
      if (text.replace(/\s+/g, ' ').trim().length < MIN_CHARS) return;
      if (!e.clipboardData) return;

      var wrap = content.closest('.ib-product-description');
      var url = (wrap && wrap.getAttribute('data-ib-copy-url')) || location.href.split('#')[0].split('?')[0];

      var holder = document.createElement('div');
      for (var i = 0; i < sel.rangeCount; i++) holder.appendChild(sel.getRangeAt(i).cloneContents());
      if (!linkFirstLongWord(holder, url)) return;

      e.clipboardData.setData('text/html', holder.innerHTML);
      e.clipboardData.setData('text/plain', text);
      e.preventDefault();
    } catch (err) {
      /* bij een fout: normaal kopiëren laten doorgaan */
    }
  });
})();
